export default "__VITE_ASSET__CDs5zAOe__"